import axios from "axios";

export const getNotifications = async (params) => {
  const { data } = await axios.get("/api/notifications", { params });
  return data;
};

export const getAllNotifications = async (params) => {
  const { data } = await axios.get("/api/notifications/all", { params });
  return data;
};

export const getUnreadCount = async () => {
  const { data } = await axios.get("/api/notifications/unread-count");
  return data;
};

export const markNotificationRead = async (id) => {
  const { data } = await axios.post(`/api/notifications/${id}/read`);
  return data;
};

export const markAllNotificationsRead = async () => {
  const { data } = await axios.post("/api/notifications/mark-all-read");
  return data;
};

export const deleteNotification = async (id) => {
  const { data } = await axios.delete(`/api/notifications/${id}`);
  return data;
};

// Notification preferences (admin)
export const getNotificationPreferences = async () => {
  const { data } = await axios.get("/api/notification-preferences");
  return data;
};

export const updateNotificationPreference = async (id, payload) => {
  const { data } = await axios.put(`/api/notification-preferences/${id}`, payload);
  return data;
};

export const resetNotificationPreferences = async () => {
  const { data } = await axios.post("/api/notification-preferences/reset");
  return data;
};
